<script>
export default {
  methods: {},
  props: ["component", "handler"],
  data: function () {
    return {};
  },
  computed: {},
  mounted: function () {},
};
</script>

<template>
  <div class="plan-tunnel-thank-you-component">
    <h1>
      {{ $vt("Thank you for the") }}
      <strong style="color: var(--statusNegative)">{{ $vt("BUY_FOR_FREE") }}</strong>
      {{ $vt("purchase") }}
    </h1>
    <f-button type="secondary" href="#/">
      <f-icon icon="fa6-arrow-right"></f-icon> {{ $vt("Home") }}
    </f-button>
  </div>
</template>

<style lang="scss">
.plan-tunnel-thank-you-component {
  justify-content: center;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;

  h1 {
    color: var(--white-a75);
    text-align: center;
    font-family: Lato;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 110%; /* 52.8px */
  }

  .f-button {
    align-self: center;
  }
}
</style>